/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/scandipwa
 */

import Link from 'Component/Link';
import { Breadcrumb as SourceBreadcrumb } from 'SourceComponent/Breadcrumb/Breadcrumb.component';

/** @namespace Pwa/Component/Breadcrumb/Component */
export class Breadcrumb extends SourceBreadcrumb {
    renderLink() {
        const {
            index,
            isDisabled
        } = this.props;

        const url = this.getLinkUrl() || {};

        return (
            <Link
              block="Breadcrumb"
              elem="Link"
              to={ url }
              tabIndex={ isDisabled ? '-1' : '0' }
            >
                <meta itemProp="item" content={ window.location.origin + url.pathname } />
                <span itemProp="name">
                    { this.renderName() }
                </span>
                <span block="Breadcrumb" elem="Chevron">{ '>' }</span>
                <meta itemProp="position" content={ index } />
            </Link>
        );
    }
}

export default Breadcrumb;
